export default [{
  key: 'global',
  title: 'global',
  value: 'global',
  desc: 'helpers in the asset will be attached to all templates'
}, {
  key: 'folder',
  title: 'folder',
  value: 'folder',
  desc: 'helpers in the asset will be attached to all templates in the same folder hierarchy'
}]
